import styled from 'styled-components/macro'

export const EvidenceTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 auto;
  min-height: 0;
  align-items: flex-end;
  overflow-y: auto;
  .tab-content,
  .tab-pane.active.show {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .container-fluid {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .row:nth-child(2) {
    flex: 1 1 max-content;
    overflow-y: auto;
  }

  .markup-section {
    padding: 12px;
  }
`
